<template>
  <div class="service-page">
    <van-nav-bar title="服务协议"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="marginTop">
      <div @click="jumpToAgreement(0)">
        <van-cell title="隐私政策" is-link></van-cell>
      </div>
      <div @click="jumpToAgreement(1)">
        <van-cell title="用户服务协议" is-link></van-cell>
      </div>
      <div @click="jumpToAgreement(2)">
        <van-cell title="法律声明" is-link></van-cell>
      </div>
      <div @click="jumpToAgreement(3)">
        <van-cell title="宜贰叁互联网医院服务协议" is-link></van-cell>
      </div>
      
      <div @click="jumpToAgreement(5)">
        <van-cell title="荷叶健康（商城）服务协议" is-link></van-cell>
      </div>  
      <div @click="jumpToAgreement(6)">
        <van-cell title="荷叶健康（问诊）服务协议" is-link></van-cell>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/auth'
export default {
  methods: {
    /**
    * @description: 跳转到我的页面
    */
    onClickLeft() {
      window.location.href = 'protocol://action/finish/'
    },
    /**
    * @description: 跳协议页
    * @param {number} 协议编号
    * @return: void
    */
    jumpToAgreement(num) {
      this.$router.push({
        path: 'serviceagreement',
        query: {
          num,
          title: 1
        }
      })
    }
  }
}
</script>
<style scoped>
#app {
  height: 100vh;
}
.service-page {
  width: 375px;
  height: 100vh;
  background: #f7f7f7;
  position: relative;
}
.infoBox {
  display: flex;
  align-items: center;
  font-size: 14px;
  background: #fff;
  padding: 15px;
}
.infoImg {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  text-align: center;
  line-height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  color: #fff;
}
.infoBox img {
  width: 50px;
  height: 50px;
  background: #3d7eff;
  border-radius: 50%;
  margin-right: 15px;
}
.infoBox .smSize {
  color: #666;
  font-size: 12px;
}
.marginTop {
  margin-top: 10px;
  font-size: 14px;
}
.logout {
  width: 100%;
  background: white;
  text-align: center;
  color: red;
  font-size: 14px;
  padding: 10px 0;
}
.call {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #323233;
  font-size: 16px;
  padding-bottom: 10px;
}
</style>
